export default __webpack_public_path__ + "static/media/icon_alert.db74f425.svg";